import * as React from 'react';
import { renderToStaticMarkup } from "react-dom/server";
import { withLocalize, LocalizeContextProps } from "react-localize-redux";
import bindAllOfThis from "src/utils/BindThisHelper";
import Languages from '../constants/Languages';
import TranslateApi from '../utils/TranslateHelper';
import DebugUtil from "src/utils/DebugUtil";

interface MultilingualLoaderProps extends LocalizeContextProps {
    onComplete?: () => void;
}

interface MissingTranslationOptions {
    translationId: string;
    languageCode: string;
    defaultTranslation: string;
}

class MultilingualLoader extends React.Component<MultilingualLoaderProps> {
    constructor(props: MultilingualLoaderProps) {
        super(props);
        bindAllOfThis(this, MultilingualLoader.prototype);

        let languages = Languages.All.map(x => { return { name: x.name, code: x.code }; });
        // I had a little too much fun doing javascript things here
        let defaultLanguage = (languages.filter(x => x.name.toLowerCase() === "english") || [languages[0]]).shift().code;

        // Initialize the multilingual module
        this.props.initialize({
            languages: languages,
            options: {
                renderToStaticMarkup,
                renderInnerHtml: true,
                defaultLanguage: defaultLanguage,
                onMissingTranslation: this.missingTranslationHandler
            }
        });

        // Updated language logic
        fetch(Languages.English.url).then(data => {
            data.json().then(result => {
                // Note for JB - Load the english first as adding additional keys does NOT seem to work properly
                // English is the most complete and will have all of the keys
                this.props.addTranslationForLanguage(result, Languages.English.code);
                if (DebugUtil.isDebugEnabled()) {
                    console.log(`English Language Loaded: ${Languages.English.name}`);
                    console.log(`Fetching remaining languages`);
                }

                var fetches = Languages.All
                    .filter(x => x !== Languages.English)
                    .map(lang => {
                        return fetch(lang.url).then(data => {
                            return data.json().then(jsonResult => {
                                this.props.addTranslationForLanguage(jsonResult, lang.code);
                                if (DebugUtil.isDebugEnabled()) {
                                    console.log(`Language Loaded: ${lang.name}`);
                                }
                            });
                        });
                    });

                    Promise.all(fetches).then(x => {
                        // JB: When we finally get a ticket that asks why the login page is in english, we can change it here
                        // JB: We also do not want to use Languages.SetActiveLanguage here. It will be set either on login or in layoutComponent
                        this.props.setActiveLanguage(Languages.English.code);
                        if (DebugUtil.isDebugEnabled()) {
                            console.warn("Loaded all langs, completing multilingual loader");
                        }
                        if (this.props.onComplete != null) {
                            this.props.onComplete();
                        } else {
                            if (DebugUtil.isDebugEnabled()) {
                                console.warn("What happened to my onComplete function?!");
                            }
                        }
                    });
            });
        });

        // **DO NOT TOUCH**
        TranslateApi.translate = (key) => this.props.translate(key).toString();
    }

    missingTranslationHandler(options: MissingTranslationOptions): string {
        console.warn(`Missing translation: Lang: ${options.languageCode} | ID: ${options.translationId}`);
        return options.defaultTranslation || "";
    }

    render() {
        return null;
    }
}

export default withLocalize(MultilingualLoader);



// WEBPACK FOOTER //
// ./src/core/MultilingualLoader.tsx